import React from 'react';
import styled from 'styled-components';

export default styled(({ value, ...rest }) => <img {...rest} />)`
  max-width: ${({ value }) => {
    switch (value) {
      case 'small':
        return '35px';
      case 'medium':
        return '52px';
      case 'large':
        return '50px';
      case 'extra-large':
        return '100px';
      default:
        return '50px';
    }
  }};
  justify-self: center;
  align-self: center;
`;
